import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { queryString } from '@cinch/oxd-utils/requests/src'

const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap'
const APIKEY = getEnv(Env.GoogleMapsApiKey)

const styleParams = [
  'feature:poi|visibility:off',
  'feature:administrative.land_parcel|element:labels|visibility:off',
  'element:labels.icon|visibility:off',
]

export default (params: any = { center: '' }) => {
  const qs = {
    key: APIKEY,
    zoom: 15,
    region: 'uk',
    format: 'JPEG',
    maptype: 'roadmap',
    components: 'country:GB',
    markers: `icon:https://i.imgur.com/Xw6oPFU.png|${params.center || ''}`,
    ...params,
  }

  return `${baseUrl}?${queryString(qs)}&style=${styleParams.join('&style=')}`
}
